import { eReportTuyenSinhActionsObj } from "../../action-types/report/IReportTuyenSinhActionTypes";
import { generateActions } from "../generateActions";

export const reportTuyenSinhActions = {
  ...generateActions(eReportTuyenSinhActionsObj, "REPORT_TUYEN_SINH"),
};
